module.exports = __webpack_public_path__ + "static/img/studiotanya.01a95b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/studiotanya.png
// module id = XpFo
// module chunks = 0